let userPromise;
const debug = window.location.hostname == 'localhost';

function getApi(url, callback) {
  if (debug) console.log('calling api GET', url);
  $("body").css("cursor", "wait");
  $.ajax({
    type: "GET",
    url,
    dataType: 'json',
    headers: { 'X-Auth-Token': window.api_token },
  })
  .then(callback)
  .catch((response) => {
    console.log(response);
    if (response.status == 401) window.location.hash = 'login';
  })
  .always(() => {
    $("body").css("cursor", "initial");
  });
}

function call(api, method, data) {
  if (debug) console.log(`calling api ${method}`, api);
  return $.ajax({
    type: method,
    url: api,
    dataType: 'json',
    headers: { 'X-Auth-Token': window.api_token },
    data,
  });
}

function loadUser(force = false) {
  if (userPromise && ! force) return userPromise;

  const dfd = $.Deferred();
  this.getApi(window.api.getuser.url, (data) => {
    const user = data && data.user;
    if (user && user.id) {
      sessionStorage.user_id = user.id;
      sessionStorage.username = `${user.firstname} ${user.lastname}`;
      sessionStorage.user_email = user.email;
      dfd.resolve(user);
    }
  });
  userPromise = dfd.promise();
  return userPromise;
}

export default {
  getApi,
  call,
  loadUser,
};
